import React from "react";
import styled, { withTheme } from "styled-components";
import DefaultTable, {
  ActionButtons,
  Line,
  ExpandableLine,
} from "../../../ui-library/CustomTable/DefaultTable";
import { Dropdown } from "react-bootstrap";
import ButtonDropdown from "../../../ui-library/ButtonDropdown/ButtonDropdown";
import TableDropDown from "../../../ui-library/TableDropDown/TableDropDown";
import { useTranslation } from "react-i18next";
import {
  decimalPlaces,
  fastingDayEmptyMeal,
  isFastingDay,
  roundMealValue,
} from "../../../../helpers/mealsHelper";
import mceIcon from "../../../../assets/svg/mce-hce-icon.svg";

const CompleteIcon = styled.i`
  color: ${(props) =>
    props?.isFastingIcon
      ? props?.theme?.blueMagenta2
      : props?.theme?.lightGreen};
  font-size: 20px;
`;

const FlagIcon = styled.i`
  color: ${(props) => props?.theme?.chiliRed};
  font-size: 20px;
`;

const MceIcon = styled.img`
  color: #383838;
  height: 20px;
  opacity: ${(props) => (props.isParent ? "50%" : null)};
`;

const StudyEntriesTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    entries,
    editMeal,
    viewMeal,
    canCreateEntriesMealLog,
    canEditEntriesMealLog,
    canViewDetailMealLog,
    loading,
    dietDiaryOptions,
  } = props;

  const { t } = useTranslation();

  const defaultProps = {
    headers: [
      { label: t("appText.date"), key: "Header1" },
      { label: t("appText.complete") },
      { label: t("appText.dietDiary.entries") },
      { label: t("appText.time") },
      { label: t("appText.dietDiary.24hourRecall") },
      { label: t("appText.dietDiary.mceOrHceMitigation") },
      { label: t("appText.description") },
      { label: t("appText.dietDiary.calories") },
      { label: t("appText.dietDiary.fats") },
      { label: t("appText.dietDiary.mediumChainFats") },
      { label: t("appText.dietDiary.longChainFats") },
      { label: t("appText.options") },
    ],
    maincolor: "#8cc13c",
    totalitems,
    hasSearch: 0,
    haspagesizefilter: 1,
    haspagination: 1,
    searchedParams,
    getData,
    isExpandable: true,
    loading,
  };

  const getDropDownItems = (entry) => {
    const dropDownMenuItems = {
      VIEW_DETAILS: {
        text: t("appText.viewDetails"),
        callBack: (meal) => viewMeal(meal),
        id: 1,
        isVisible: canViewDetailMealLog,
      },
      EDIT: {
        text: t("appText.edit"),
        callBack: (meal) => editMeal(meal),
        id: 2,
        isVisible: canEditEntriesMealLog,
      },
    };
    return Object.values(dropDownMenuItems);
  };

  const isCompleted = (entry) => {
    return entry.meals.find((meal) => meal.isCompleted);
  };

  const is24HRecall = (entry) => {
    return entry.meals.find((meal) => meal.is24hRecall);
  };

  const isHceMceEvent = (entry) => {
    return entry.meals.find((meal) => meal.hceMceEvent);
  };

  const countNoFastingDay = (meals) => {
    const totalItems = meals.filter(
      (meal) => meal?.json !== fastingDayEmptyMeal
    );
    return totalItems?.length;
  };

  return (
    <DefaultTable {...defaultProps}>
      <ActionButtons>
        {canCreateEntriesMealLog && dietDiaryOptions && (
          <ButtonDropdown
            size="sm"
            title="Add new"
            options={Object.values(dietDiaryOptions).sort(
              (a, b) => a.order < b.order
            )}
          />
        )}
      </ActionButtons>
      {entries?.map((entry, i) => (
        <ExpandableLine key={`expandable-${entry}-${i}`}>
          <Line key={`parent-${entry}-${i}`}>
            <b>
              <span>{entry?.date}</span>
            </b>
            <span>
              {(isCompleted(entry) || isFastingDay(entry)) && (
                <CompleteIcon
                  isFastingIcon={isFastingDay(entry)}
                  className="fas fa-check-circle"
                />
              )}
            </span>
            <span>
              {isFastingDay(entry) ? "-" : countNoFastingDay(entry?.meals)}
            </span>
            <span>-</span>
            <span>
              {is24HRecall(entry) && <FlagIcon className="fas fa-flag" />}
            </span>
            <span>
              {isHceMceEvent(entry) && <MceIcon src={mceIcon} isParent />}
            </span>
            <span>
              {isFastingDay(entry) ? t("appText.fastingDayLabel") : "-"}
            </span>
            <span>
              {isFastingDay(entry)
                ? "-"
                : Number(roundMealValue(entry?.calories.value)).toFixed(
                    decimalPlaces
                  )}{" "}
              {isFastingDay(entry)
                ? ""
                : entry?.calories.unit
                ? entry?.calories.unit
                : entries[i + 1]?.calories.unit}
            </span>
            <span>
              {isFastingDay(entry)
                ? "-"
                : Number(roundMealValue(entry?.fats.value)).toFixed(
                    decimalPlaces
                  )}{" "}
              {isFastingDay(entry)
                ? ""
                : entry?.fats.unit
                ? entry?.fats.unit
                : entries[i + 1]?.fats.unit}
            </span>
            <span>
              {isFastingDay(entry)
                ? "-"
                : Number(roundMealValue(entry?.mediumChainFats.value)).toFixed(
                    decimalPlaces
                  )}{" "}
              {isFastingDay(entry)
                ? ""
                : entry?.mediumChainFats.unit
                ? entry?.mediumChainFats.unit
                : entries[i + 1]?.mediumChainFats.unit}
            </span>
            <span>
              {isFastingDay(entry)
                ? "-"
                : Number(roundMealValue(entry?.longChainFats.value)).toFixed(
                    decimalPlaces
                  )}{" "}
              {isFastingDay(entry)
                ? ""
                : entry?.longChainFats.unit
                ? entry?.longChainFats.unit
                : entries[i + 1]?.longChainFats.unit}
            </span>
            <span></span>
          </Line>
          {isFastingDay(entry)
            ? "-"
            : entry?.meals?.map(
                (child, k) =>
                  !isFastingDay(child) && (
                    <Line key={`child-${child}-${k}`}>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span>{child?.time}</span>
                      <span>
                        {child?.is24hRecall && (
                          <FlagIcon className="fas fa-flag" />
                        )}
                      </span>
                      <span>
                        {child?.hceMceEvent && <MceIcon src={mceIcon} />}
                      </span>
                      <span>{child?.description}</span>
                      <span>
                        {Number(roundMealValue(child?.calories.value)).toFixed(
                          decimalPlaces
                        )}{" "}
                        {child?.calories.unit}
                      </span>
                      <span>
                        {Number(roundMealValue(child?.fats.value)).toFixed(
                          decimalPlaces
                        )}{" "}
                        {child?.fats.unit}
                      </span>
                      <span>
                        {Number(
                          roundMealValue(child?.mediumChainFats.value)
                        ).toFixed(decimalPlaces)}{" "}
                        {child?.mediumChainFats.unit}
                      </span>
                      <span>
                        {Number(
                          roundMealValue(child?.longChainFats.value)
                        ).toFixed(decimalPlaces)}{" "}
                        {child?.longChainFats.unit}
                      </span>

                      <TableDropDown>
                        {getDropDownItems(entry)
                          .filter((dropDownItem) => dropDownItem.isVisible)
                          .map((item, index) => (
                            <Dropdown.Item
                              key={index}
                              bsPrefix="dropdown-item"
                              onSelect={() => item.callBack(child)}
                            >
                              {item.text}
                            </Dropdown.Item>
                          ))}
                      </TableDropDown>
                    </Line>
                  )
              )}
        </ExpandableLine>
      ))}
    </DefaultTable>
  );
};

export default withTheme(StudyEntriesTable);
